import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';

import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './Error.css';
import Box from '../../../hoc/Box/Box';
import axios from '../../../axios-local-api';
import Input from '../../../components/UI/Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import { AiFillWarning } from "react-icons/ai";

class Error extends Component {
  state = {    
    formIsValid: false
  }

  render() {
    if(this.props.showOldView) {
      return (
        <div className={classes.Error}>
            <div id = {this.props.id ? this.props.id : 'ErrorMsg'} className={classes.HeaderRow}>
            <h4 style={{ color:'#d6312b' }}>Error!</h4>
            </div>
        </div>
      );
    }
    // console.log('this.props.customMsg :::', this.props.customMsg);
    return (
      <div style={{ padding: "0.5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <AiFillWarning color="#F93875" size={40} />
            <h2>Error {this.props.errorStatus || ''}</h2>
        </div>
        <p style={{ marginBottom: "2rem" }}>
          {this.props.customMsg || 'UpStream service not available. Please refresh the page and try again. If error persists, please contact your supervisor.'}
        </p>
      </div>
    )
  }
}

export default Error;
